<template>
    <input
        ref="inputRef"
        :value="props.modelValue"
        @input="emit('update:modelValue', $event.target.value)" />
</template>

<script setup>
    import { ref, onMounted } from 'vue'
    const inputRef = ref(null)
    const emit = defineEmits(['update:modelValue'])
    const props = defineProps({
        modelValue: {
            type: String,
            default: '',
        },
    })
    onMounted(() => {
        if (inputRef.value) {
            inputRef.value.focus()
            // auto scroll if applicable
            if (inputRef.value.scrollIntoViewIfNeeded) {
                inputRef.value.scrollIntoViewIfNeeded()
            } else if (inputRef.value.scrollIntoView) {
                inputRef.value.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
            }
        }
    })
</script>
